import {Link, isRouteErrorResponse, useRouteError} from 'react-router';
import {useTranslation} from 'react-i18next';
import {Button, Card, Container} from '@goproblems/ui';

export const RouteErrorBoundary = () => {
    const {t} = useTranslation();
    const error = useRouteError();
    const status = isRouteErrorResponse(error) ? error.status : null;
    const errorDetails =
        error instanceof Error
            ? error.stack ?? error.message
            : typeof error === 'string'
              ? error
              : status
                ? `HTTP ${status}`
                : null;

    return (
        <Container as="main" className="py-5">
            <Card className="mx-auto max-w-xl">
                <div className="card-body p-4 text-center">
                    <h1 className="h3">
                        {t('route_error.title', {
                            defaultValue: 'Something went wrong',
                        })}
                    </h1>
                    <p className="mb-4 text-body-secondary">
                        {status === 404
                            ? t('route_error.not_found', {
                                  defaultValue: 'This page could not be found.',
                              })
                            : t('route_error.description', {
                                  defaultValue:
                                      'We could not load this page. Please try again.',
                              })}
                    </p>
                    <div className="d-flex justify-content-center gap-2">
                        <Button onClick={() => window.location.reload()}>
                            {t('route_error.try_again', {
                                defaultValue: 'Try again',
                            })}
                        </Button>
                        <Link to="/" className="btn btn-outline-secondary">
                            {t('route_error.go_home', {
                                defaultValue: 'Go home',
                            })}
                        </Link>
                    </div>
                    {import.meta.env.DEV && errorDetails && (
                        <details open className="mt-4 text-start">
                            <summary className="cursor-pointer text-body-secondary">
                                {t('route_error.developer_details', {
                                    defaultValue: 'Developer details',
                                })}
                            </summary>
                            <pre className="mt-2 overflow-auto rounded bg-body-tertiary p-3 text-wrap small">
                                {errorDetails}
                            </pre>
                        </details>
                    )}
                </div>
            </Card>
        </Container>
    );
};
